import React from 'react';
import { MuiBox, InputField, Typography } from '@kis-technologies/kis-ui';
import { useDecimalField } from 'hooks/useDecimalField';
import { useStyles } from './styled';
import { FeeInputProps } from './types';

export const FeeInput: React.FC<FeeInputProps> = (props: FeeInputProps) => {
  const { label, amount, percentage, onAmountChange, onPercentageChange, disabled = false } = props;

  const classes = useStyles();

  const amountField = useDecimalField({ value: amount, onChange: onAmountChange, min: 0 });
  const percentageField = useDecimalField({ value: percentage, onChange: onPercentageChange, min: 0, max: 100 });

  return (
    <MuiBox>
      <Typography className={classes.formLabel}>{label}</Typography>
      <MuiBox display="flex" gap="16px" className={classes.formBox}>
        <MuiBox>
          <InputField
            align="right"
            label="Amount"
            type="text"
            value={amountField.displayedValue}
            disabled={disabled}
            onFocus={amountField.handleFocus}
            onChange={(e) => amountField.handleChange(e.target.value)}
            onBlur={amountField.handleBlur}
            startIcon="$"
            size="small"
            inputProps={{ inputMode: 'decimal' }}
            sx={{
              width: { xs: '262px', sm: '175px!important' },
              height: '45px'
            }}
          />
        </MuiBox>
        <MuiBox>
          <InputField
            align="right"
            type="text"
            label="Percentage"
            value={percentageField.displayedValue}
            disabled={disabled}
            onFocus={percentageField.handleFocus}
            onChange={(e) => percentageField.handleChange(e.target.value)}
            onBlur={percentageField.handleBlur}
            endIcon="%"
            size="small"
            inputProps={{ inputMode: 'decimal' }}
            sx={{
              width: { xs: '262px', sm: '175px' },
              height: '45px'
            }}
          />
        </MuiBox>
      </MuiBox>
    </MuiBox>
  );
};
